import styled from 'styled-components'

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`

export default Row

